import { render, staticRenderFns } from "./WaiverView.vue?vue&type=template&id=c4fac174&scoped=true&lang=pug"
import script from "./WaiverView.vue?vue&type=script&lang=js"
export * from "./WaiverView.vue?vue&type=script&lang=js"
import style0 from "./WaiverView.vue?vue&type=style&index=0&id=c4fac174&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4fac174",
  null
  
)

export default component.exports